import type { StatusText } from './types.js';

const statusTexts: Partial<StatusText> = {
  Fulltime: { full: 'Avslutad', short: 'SLUT' },
  Ended: { full: 'Avslutad', short: 'SLUT' },
};

export const config = {
  statusTexts,
};
